module.exports = __webpack_public_path__ + "static/media/NO.ed7007a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/NO.svg
// module id = 2229
// module chunks = 7